import { cn } from "@/lib/utils";

/** Two-tone section heading used across the landing page. */
export function SectionHeading({ eyebrow, title, accent, description, className }: { eyebrow?: string; title: string; accent?: string; description?: string; className?: string }) {
  return (
    <div className={cn("max-w-2xl", className)}>
      {eyebrow && <p className="text-[13px] text-muted-foreground mb-3">{eyebrow}</p>}
      <h2 className="text-[30px] sm:text-[40px] font-medium tracking-[-0.03em] leading-[1.08]">
        {title}
        {accent && <span className="block text-subtle">{accent}</span>}
      </h2>
      {description && <p className="text-[15px] sm:text-base text-muted-foreground mt-4 leading-relaxed">{description}</p>}
    </div>
  );
}

export const SECTION_CLASS = "mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24 scroll-mt-20";
